import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledArchiveGrid = styled.div<{
  gridTheme?: string;
}>`
  .archive-grid {
    background-color: var(--color-mid-blue);
    text-align: center;

    @media ${breakpoints.tablet} {
      -webkit-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.3);
      -moz-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.3);
      box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.3);
    }

    ${({ gridTheme }) => {
      if (gridTheme === 'default') {
        return '';
      }

      if (gridTheme === 'transparent') {
        return `
          background-color: transparent;
          @media ${breakpoints.tablet} {
            box-shadow: none;
            -webkit-box-shadow: none;
            -moz-box-shadow: none;
          }
        `;
      }

      return '';
    }}

    &__title {
      color: var(--colors-primary-bright);
    }

    &__grid {
      display: grid;
      gap: 2rem;
      padding-top: 2rem;
      padding-bottom: 2rem;

      @media ${breakpoints.tablet} {
        grid-template-columns: repeat(2, 1fr);
        padding: 3rem 5rem;
      }

      @media ${breakpoints.desktopLarge} {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    &__item {
      margin-top: 75px;

      &.fade-in {
        animation: fadeIn 0.5s ease-in-out;
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .no-results {
      grid-column: 1 / -1;
      justify-self: center;
    }
  }
`;
